import {FIELD_TYPES, FieldType} from 'schemas/fields/SchemaFieldConstants';

export type AutofillNames = 'Parts' | 'Translations' | 'Transcriptions';

export interface AutofillCompatibleBioentityOption {
  name: AutofillNames;
  fieldType: FieldType;
}

export const AUTOFILL_COMPATIBLE_BIOENTITY_OPTIONS: Array<AutofillCompatibleBioentityOption> = [
  {
    name: 'Parts',
    fieldType: FIELD_TYPES.PART_LINK.type,
  },
  {
    name: 'Transcriptions',
    fieldType: FIELD_TYPES.TRANSCRIPTION_LINK.type,
  },
  {
    name: 'Translations',
    fieldType: FIELD_TYPES.TRANSLATION_LINK.type,
  },
];
